import { useEffect, useState } from 'react';
import { fetchWhatsAppLinks } from '../../settings/whatsappApi';

function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12.04 2C6.58 2 2.15 6.4 2.15 11.83c0 1.74.46 3.44 1.34 4.94L2 22l5.39-1.41a10.1 10.1 0 0 0 4.65 1.12h.01c5.46 0 9.89-4.4 9.89-9.83C21.94 6.4 17.5 2 12.04 2zm5.76 13.92c-.24.68-1.4 1.3-1.94 1.38-.5.08-1.12.11-1.81-.11-.42-.14-.95-.31-1.64-.6-2.88-1.24-4.76-4.14-4.9-4.33-.14-.19-1.16-1.54-1.16-2.94s.73-2.08 1-2.37c.24-.27.64-.39 1.02-.39.13 0 .24 0 .35.01.31.01.47.03.68.52.24.58.83 2 .9 2.15.07.14.12.32.02.51-.09.19-.14.31-.28.48-.14.16-.29.36-.41.48-.14.13-.28.28-.12.54.16.27.72 1.18 1.54 1.91 1.06.95 1.95 1.24 2.22 1.38.27.14.43.12.59-.07.16-.19.68-.79.86-1.06.18-.27.36-.22.6-.13.24.09 1.54.73 1.8.86.27.13.44.2.51.31.06.11.06.64-.18 1.32z"
      />
    </svg>
  );
}

function linkItems(links) {
  return [
    links?.group_url ? { kind: 'group', href: links.group_url, label: 'Join WhatsApp Group' } : null,
    links?.channel_url ? { kind: 'channel', href: links.channel_url, label: 'Follow WhatsApp Channel' } : null,
  ].filter(Boolean);
}

export function WhatsAppCommunityLinks({ links, variant = 'compact' }) {
  const items = linkItems(links);
  if (!items.length) return null;
  const cta = variant === 'cta';

  return (
    <section className={`blrc-wa ${cta ? 'blrc-wa-cta' : 'blrc-wa-compact'}`} aria-label="WhatsApp community">
      <style>{`
        .blrc-wa-row { display: flex; flex-wrap: wrap; gap: 12px; }
        .blrc-wa-link {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          flex: 1 1 220px;
          min-height: 44px;
          padding: 10px 16px;
          border-radius: 999px;
          text-decoration: none;
          font-weight: 700;
          letter-spacing: 0.01em;
          line-height: 1.2;
          border: 1px solid transparent;
          transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease, color 0.18s ease;
        }
        .blrc-wa-link:hover { transform: translateY(-2px); }
        .blrc-wa-link:focus-visible { outline: 3px solid #a68947; outline-offset: 2px; }
        .blrc-wa-group { background: #25D366; color: #075E54; box-shadow: 0 8px 18px rgba(37, 211, 102, 0.22); }
        .blrc-wa-group:hover { background: #1ebe5d; box-shadow: 0 12px 22px rgba(37, 211, 102, 0.32); color: #05463d; }
        .blrc-wa-channel { background: #075E54; color: #fff; box-shadow: 0 8px 18px rgba(7, 94, 84, 0.2); }
        .blrc-wa-channel:hover { background: #05463d; box-shadow: 0 12px 22px rgba(7, 94, 84, 0.28); color: #fff; }
        .blrc-wa-cta { margin-top: 40px; padding: 22px; border-radius: 16px; background: linear-gradient(180deg, #f4fbf6 0%, #eef8f1 100%); border: 1px solid #d7efe0; }
        .blrc-wa-cta h2 { margin: 0 0 6px; font-size: 1.2rem; color: #16352f; }
        .blrc-wa-cta p { margin: 0 0 16px; color: #4d665f; }
        .blrc-wa-cta .blrc-wa-link { min-height: 52px; padding: 14px 18px; font-size: 1rem; }
        .blrc-wa-compact { margin: 0 0 22px; }
        .blrc-wa-compact .blrc-wa-link { font-size: 0.95rem; }
        @media (max-width: 640px) {
          .blrc-wa-link { flex-basis: 100%; }
        }
      `}</style>
      {cta ? (
        <>
          <h2>Stay connected on WhatsApp</h2>
          <p>Get case-study updates from BLRC in the group chat or on the channel.</p>
        </>
      ) : null}
      <div className="blrc-wa-row">
        {items.map((item) => (
          <a
            key={item.kind}
            className={`blrc-wa-link blrc-wa-${item.kind}`}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsAppIcon />
            <span>{item.label}</span>
          </a>
        ))}
      </div>
    </section>
  );
}

export function useWhatsAppLinks() {
  const [links, setLinks] = useState({ group_url: '', channel_url: '' });

  useEffect(() => {
    let active = true;
    fetchWhatsAppLinks().then((next) => {
      if (active) setLinks(next);
    });
    return () => {
      active = false;
    };
  }, []);

  return links;
}
